import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";

export const activarMembresia = async ({usuario}) => {

    //La fecha de membresia se guarda en usuario

    let nuevaFecha = new Date().getTime() + 1000 * 60 * 60 * 24 * 30
    let dox = await actualizarDoc('cuentas', usuario.id, {fechaMembresia: nuevaFecha})

    return dox

}